/**
 * ฟอร์แมตตัวเลขราคา/จำนวนเงิน สำหรับแสดงผล
 * ใช้ร่วมกันทั้งโมดูล (moderation, fees, mechanics ฯลฯ)
 */

const DEFAULT_LOCALE = "la";
const DEFAULT_FRACTION_DIGITS = 0;
const NULL_PLACEHOLDER = "—";

export type FormatPriceOptions = {
  /** Locale สำหรับ Intl.NumberFormat (ค่าเริ่มต้น "la" สำหรับภาษาลาว) */
  locale?: string;
  /** จำนวนทศนิยม (ค่าเริ่มต้น 2) */
  fractionDigits?: number;
  /** ถ้า true จะต่อท้าย " " + currency (ค่าเริ่มต้น true) */
  appendCurrency?: boolean;
};

/**
 * แปลงตัวเลขเป็นข้อความพร้อมสกุลเงิน
 *
 * @param price - จำนวน (ถ้า null/undefined จะคืน "—")
 * @param currency - สกุลเงิน เช่น "LAK", "THB", "USD"
 * @param options - locale, fractionDigits, appendCurrency
 * @example
 * formatPrice(85000, "LAK")           // "85,000.00 LAK"
 * formatPrice(85000, "LAK", { locale: "lo-LA" })
 * formatPrice(10.5, "", { appendCurrency: false })  // "10.50"
 */
export function formatPrice(
  price: number | null | undefined,
  currency: string,
  options: FormatPriceOptions = {},
): string {
  if (price == null || Number.isNaN(price)) {
    return NULL_PLACEHOLDER;
  }

  const {
    locale = DEFAULT_LOCALE,
    fractionDigits = DEFAULT_FRACTION_DIGITS,
    appendCurrency = true,
  } = options;

  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(Number(price));

  if (appendCurrency && currency.trim()) {
    return `${formatted} ${currency.trim()}`;
  }
  return formatted;
}
